import { isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import { REPLACEABLE_8_PREFIXES } from './constants';

export const clearPhoneNumber = (phone: string): string => {
	if (!phone) {
		return '';
	}

	return phone.replace(/[+() ]/g, '');
};

export const sanitizePhoneInput = (value: string): string => {
	return value.replace(/[^0-9]/g, '');
};

/**
 * Приводит телефонный номер к единому стандарту (нормализация).
 * Исправляет ввод с 8 на 7, обрабатывает 10-значные номера и удаляет лишние префиксы.
 */
export const normalizePhoneNumber = (value: string): string => {
	if (!value) {
		return '';
	}

	// Очистка от лишних символов (скобки, тире, пробелы)
	let cleaned = sanitizePhoneInput(value);

	// 1. Исправляем 8 на 7 в начале (для 87... и 89...)
	const shouldFixEight = REPLACEABLE_8_PREFIXES.some(prefix => cleaned.startsWith(prefix));

	if (shouldFixEight) {
		cleaned = '7' + cleaned.slice(1);
	}

	// 2. Если номер начинается с 9 и это 10-значный номер, добавляем 7
	if (cleaned.startsWith('9') && cleaned.length === 10) {
		cleaned = '7' + cleaned;
	}

	// 3. Если пользователь дальшее водит номер, то убираем первую семерку
	if (cleaned.startsWith('79') && cleaned.length > 11) {
		cleaned = cleaned.slice(1);
	}

	// 4. Возвращаем плюс, если он был в исходном значении
	return value.startsWith('+') ? `+${cleaned}` : cleaned;
};

export const isCorrectPhoneNumber = (phone: string) => {
	const phoneNumber = parsePhoneNumberFromString(phone, 'RU');

	if (!phoneNumber) {
		return false;
	}

	return isValidPhoneNumber(clearPhoneNumber(phone), phoneNumber.country);
};

export const parsePhone = (value: string): string => {
	let parsedPhone: string;

	if (value.startsWith('8') && clearPhoneNumber(value).length === 11 && parsePhoneNumberFromString(value, 'RU')) {
		parsedPhone = parsePhoneNumberFromString(value, 'RU').formatInternational();
	} else if (value.startsWith('9') && parsePhoneNumberFromString(value, 'RU')) {
		parsedPhone = parsePhoneNumberFromString(value, 'RU').formatInternational();
	} else {
		parsedPhone = formatPhoneNumberIntl(value) || formatPhoneNumberIntl(`+${value}`);
	}

	return parsedPhone;
};
